import { render } from "./OtiSquare.vue?vue&type=template&id=49db6ad0&scoped=true"
import script from "./OtiSquare.vue?vue&type=script&lang=js"
export * from "./OtiSquare.vue?vue&type=script&lang=js"

import "./OtiSquare.vue?vue&type=style&index=0&id=49db6ad0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49db6ad0"]])

export default __exports__